import React from "react"
import { useSelector } from "react-redux"
import ProfileFetcher from "./ProfileFetcher"

export default function ProfileGuard({ children, placeholder }) {
  const { authenticated } = useSelector((state) => state.app)

  const { isLoaded: isProfileLoaded } = useSelector((state) => state.profile)

  if (!isProfileLoaded && placeholder)
    return (
      <>
        {authenticated && <ProfileFetcher />}
        {placeholder}
      </>
    )

  return <>{children}</>
}
